export default __webpack_public_path__ + "static/home-bg-7003d331bf15e657292410fe2e96b9a6.jpg";